import _defineProperty from '@babel/runtime/helpers/defineProperty';
import 'react';
import style from './veiwall-button.style.js';
import RichMessage from '../common/rich-message.js';
import DataLayer from '../common/data-layer.js';
import { jsx, jsxs } from '@emotion/react/jsx-runtime';

function ownKeys(object, enumerableOnly) {
  var keys = Object.keys(object);

  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);
    enumerableOnly && (symbols = symbols.filter(function (sym) {
      return Object.getOwnPropertyDescriptor(object, sym).enumerable;
    })), keys.push.apply(keys, symbols);
  }

  return keys;
}

function _objectSpread(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = null != arguments[i] ? arguments[i] : {};
    i % 2 ? ownKeys(Object(source), !0).forEach(function (key) {
      _defineProperty(target, key, source[key]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) {
      Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
    });
  }

  return target;
}

var CircleArrow = function CircleArrow(props) {
  return jsxs("svg", _objectSpread(_objectSpread({}, props), {}, {
    children: [jsx("path", {
      d: "M12.5 22c5.523 0 10-4.477 10-10s-4.477-10-10-10-10 4.477-10 10 4.477 10 10 10Z",
      stroke: "url(#a)",
      strokeWidth: "2",
      strokeLinejoin: "round"
    }), jsx("path", {
      d: "M17 10.5 12.5 15 8 10.5",
      stroke: "url(#b)",
      strokeWidth: "2",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }), jsxs("defs", {
      children: [jsxs("linearGradient", {
        id: "a",
        x1: "29.557",
        y1: "31.38",
        x2: "-12.552",
        y2: "28.88",
        gradientUnits: "userSpaceOnUse",
        children: [jsx("stop", {
          offset: ".01",
          stopColor: "#1340BF"
        }), jsx("stop", {
          offset: ".98",
          stopColor: "#00B8FF"
        })]
      }), jsxs("linearGradient", {
        id: "b",
        x1: "20.175",
        y1: "17.111",
        x2: "1.424",
        y2: "14.884",
        gradientUnits: "userSpaceOnUse",
        children: [jsx("stop", {
          offset: ".01",
          stopColor: "#1340BF"
        }), jsx("stop", {
          offset: ".98",
          stopColor: "#00B8FF"
        })]
      })]
    })]
  }));
};

CircleArrow.defaultProps = {
  width: "25",
  height: "24",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
};

var ViewallButton = function ViewallButton(_ref) {
  var onAction = _ref.onAction,
      active = _ref.active;
  return jsx(DataLayer, {
    selector: "[InternetPackage.showAllButton]",
    triggers: ['click'],
    context: {
      name: 'Show all'
    },
    render: function render(ref) {
      return jsxs("div", {
        ref: ref,
        css: style.buttonContainer,
        onClick: function onClick() {
          return onAction('view-all');
        },
        children: [jsx("div", {
          css: style.buttonText(active),
          children: jsx(RichMessage, {
            id: "InternetPackage.showAllButton",
            defaultMessage: "Show all",
            xTags: ['title']
          })
        }), jsx("div", {
          css: style.buttonText(!active),
          children: jsx(RichMessage, {
            id: "InternetPackage.showLessButton",
            defaultMessage: "Show Less",
            xTags: ['title']
          })
        }), jsx("div", {
          css: style.circleArrow(active),
          children: jsx(CircleArrow, {})
        })]
      });
    }
  });
};

export { ViewallButton as default };